import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="pt-36 md:pt-40 pb-24 bg-[#FAF6F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="overline">our story</p>
          <h1 className="font-display text-5xl md:text-7xl italic font-light mt-4 leading-tight">A Small Team. One Country. Every Detail.</h1>
        </div>

        <div className="mt-16 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-7 space-y-6 text-[#23170E]">
            <p className="text-xl md:text-2xl font-display italic font-light leading-relaxed">
              Apex Safaris was started in Arusha by a group of guides who'd worked for the big
              operators — and grew tired of the rushed itineraries, the cookie-cutter routes, the way crews
              were sometimes treated.
            </p>
            <p className="leading-relaxed text-[#23170E]/65">
              We built something different. A small outfit, owned and run by Tanzanians, where every safari is
              planned by the person who'll actually lead it. Where crews earn fair wages because that's the
              only way that's right. Where we tell you honestly what's worth doing — and what isn't.
            </p>
            <p className="leading-relaxed text-[#23170E]/65">
              We don't try to be the cheapest, and we don't try to be the flashiest. We try to be the most
              trustworthy guides you'll ever meet — and the planners who actually pick up the phone when you
              call from the airport at 2am.
            </p>
          </div>
          <div className="md:col-span-5">
            <img src="https://images.pexels.com/photos/20852883/pexels-photo-20852883.jpeg?w=1200" alt="Guide" className="w-full aspect-[4/5] object-cover rounded-3xl" />
          </div>
        </div>

        <div className="mt-24 grid md:grid-cols-3 gap-10">
          {[
            { n: "Pole pole", t: "Slowly, with care.", d: "We don't rush. The best sightings come to people who wait; we built our company around it." },
            { n: "Karibu", t: "Welcome, always.", d: "You'll be greeted in Swahili, in our home, with our food. This is your trip — but it's our country." },
            { n: "Asante", t: "Gratitude in action.", d: "Fair wages, ethical lodges, conservation contributions on every booking. The wild gives back when we give first." },
          ].map((v) => (
            <div key={v.n} className="bg-[#FFFFFF] rounded-3xl p-8 border border-[#E2D5C3]">
              <p className="font-display text-3xl italic text-[#A6521B]">{v.n}</p>
              <h3 className="font-marcellus text-2xl mt-3">{v.t}</h3>
              <p className="mt-3 text-[#23170E]/65 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 bg-[#F1E8DC] rounded-3xl p-12 md:p-16 text-center">
          <p className="overline">ready to talk?</p>
          <h2 className="font-display text-4xl md:text-6xl italic font-light mt-4">Let's plan something unforgettable.</h2>
          <Link to="/contact" data-testid="about-cta-contact" className="inline-flex mt-10 btn-pill btn-pill-primary">
            Get in touch
          </Link>
        </div>
      </div>
    </div>
  );
}
